export default __webpack_public_path__ + "static/media/manage-class.11a415d4.svg";